module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-flakes-soyaben-lid.b42205ac.png";